"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.separateFiltersAndSortFromUrlPro = void 0;
var separateFiltersAndSortFromUrl = function separateFiltersAndSortFromUrl(activeFiltersString, url) {
  var _ref;
  var urlAfterQuestionMark;
  url = (_ref = activeFiltersString || url) === null || _ref === void 0 ? void 0 : _ref.replace(/\?.*/g, function (urlWithQuestionMark) {
    urlAfterQuestionMark = urlWithQuestionMark.substring(1);
    return "";
  });
  return {
    urlAfterQuestionMark: urlAfterQuestionMark,
    activeFilters: activeFiltersString ? url : ""
  };
};
var separateFiltersAndSortFromUrlPro = function separateFiltersAndSortFromUrlPro(activeFiltersString, url) {
  var _url;
  var urlAfterQuestionMark;
  url = (_url = url) === null || _url === void 0 ? void 0 : _url.replace(/\?.*/g, function (urlWithQuestionMark) {
    urlAfterQuestionMark = urlWithQuestionMark.substring(1);
    return "";
  });
  return {
    urlAfterQuestionMark: urlAfterQuestionMark,
    activeFilters: activeFiltersString
  };
};
exports.separateFiltersAndSortFromUrlPro = separateFiltersAndSortFromUrlPro;
var _default = separateFiltersAndSortFromUrl;
exports["default"] = _default;